import { GameReplicatedTimeout, GameReplicatedTimeoutConfig } from "../../../core/game/server/GameReplicatedTimeout";
class CommitAnswerTimeout extends GameReplicatedTimeout {
    callback() {
        this.context.getReplicatedObjectById(this.data.clueId).commitAnswerImmediate(this.data.answer, this.data.sourceId, this.data.sourceUsername);
    }
    ;
}
export function createCommitAnswerTimeout(data, writerContext) {
    return writerContext.createReplicatedTimeout('CommitAnswerTimeout', data, [data.clueId]);
}
export const CommitAnswerTimeoutConfig = new GameReplicatedTimeoutConfig('CommitAnswerTimeout', CommitAnswerTimeout);
//# sourceMappingURL=CommitAnswerTimeout.js.map